(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:RegulationDetailsCtrl
     *
     * @description
     *
     */
    angular
        .module('trainingSchedule')
        .controller('AssignExternalTraineesDetailsCtrl', AssignExternalTraineesDetailsCtrl);

    function AssignExternalTraineesDetailsCtrl(modalParams,$uibModalInstance,AssignExternalTraineesFactory,
    		CommonMasterData,TrainingScheduleService,MessageService,EventManagerService) {
        var vm = this;

        vm.model = {
            externalTrainee : AssignExternalTraineesFactory.getEmptyExternalTraineeDTO(),
            externalTraineeList:[],
            masterList : {
                airlines : [],
                crewTypes : [],
                crewSuggesions:[]
              }
        };

        vm.onConfirmClick = function () {
            $uibModalInstance.close(modalParams);
        };
        
        vm.addExternalTraineeToList = function() {
        	
        	if(!isValidateExternalTraineeDataExist()){
        		return;
        	}
        	
        	var externalTrainee = AssignExternalTraineesFactory.toExternalTraineeDTO(vm.model.externalTrainee,
        			vm.model.externalTraineeList.length,modalParams.trainingSlotId);
        	vm.model.externalTraineeList.push(externalTrainee);
        	vm.model.externalTrainee = AssignExternalTraineesFactory.getEmptyExternalTraineeDTO();
        }
        
		vm.removeSellection = function(index) {
			if (index > -1) {
				var tempArray = [];
				for (var i = 0; i < vm.model.externalTraineeList.length; i++) {
					var tempObj = vm.model.externalTraineeList[i];
					if(tempObj.index !==index){
						tempArray.push(tempObj);
					}
				}
				vm.model.externalTraineeList = tempArray;
			}
		}
		
		vm.addExternalTraineesToTheTraining = function() {
			TrainingScheduleService.addExternalTrainees(vm.model.externalTraineeList,
				function (response) {
	                if(response.success){
	                	vm.model.externalTraineeList = [];
	                    MessageService.success('External trainees successfully added.');
	                }else{
	                    MessageService.error(response.errors[0]);
	                }
            	},
	            function (error) {
	                MessageService.error(error);
	            });
		}
		
		vm.closePopup= function(){
			EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_ASSIGN_CREW.ON_CLOSE_EXTERNAL_CREW_POPUP);
		}
		
		function isValidateExternalTraineeDataExist(){
			var ext = vm.model.externalTrainee;
			return (isNullOrEmpty(ext.name)|| isNullOrEmpty(ext.id)|| isNullOrEmpty(ext.crewType)|| isNullOrEmpty(ext.institute)) ? false : true;
		}
		
		function isNullOrEmpty(value){
			
			return(value == null || value == "")?true:false;
		}
		
		function getExternalCrewSuggesion(){
			CommonMasterData.searchExternalTraineeSuggession(function (response) {
		        vm.model.masterList.crewSuggesions = response;
		      },
		      function () {
		        console.log('External crew data retrieval error');
		      }
		    );
		}
		
		function getAirlineNames() {
			CommonMasterData.loadAirlineList(false,function (response) {
		        vm.model.masterList.airlines = response;
		      },
		      function () {
		        console.log('Airline data retrieval error');
		      }
		    );
        }
		
		function getCrewTypes(){
			CommonMasterData.getCrewTypeList(
			  function (response) {
		        vm.model.masterList.crewTypes = response;
		      },
		      function () {
		        console.log('crew type data retrieval error');
		      }
		    );
		}
		
		function init() {
			getExternalCrewSuggesion();
			getAirlineNames();
			getCrewTypes();
        }
		
		init();
        
    }
}());
